export const SELECTED_NAME_OPTION_ID = 'selected-item-name';
export const selectedNameOption = (name)=>({
        id: SELECTED_NAME_OPTION_ID,
        name,
        costString: '',
        sectionLabel: ''
    });
export const agreementOptionKey = (option)=>option.stageNumber != null ? "".concat(option.id, ":stage-").concat(option.stageNumber) : option.id;
export function buildItemServiceSelectOptions(param) {
    let { agreementOptions, outOfScopeTemplates, formatTemplateCost, inAgreementSectionLabel, outOfScopeSectionLabel } = param;
    const agreementItems = agreementOptions.map((option)=>({
            id: agreementOptionKey(option),
            name: option.name,
            costString: option.costString,
            sectionLabel: inAgreementSectionLabel,
            selection: {
                kind: 'agreementService',
                option
            }
        }));
    const outOfScopeItems = outOfScopeTemplates.map((template)=>({
            id: template.id,
            name: template.name,
            costString: formatTemplateCost(template),
            sectionLabel: outOfScopeSectionLabel,
            selection: {
                kind: 'outOfScopeTemplate',
                template
            }
        }));
    return [
        ...agreementItems,
        ...outOfScopeItems
    ];
}
export function disabledItemServiceOptions(agreementOptions) {
    return agreementOptions.filter((option)=>option.disabledReason.isDisabled).map((option)=>({
            id: agreementOptionKey(option),
            tooltip: option.disabledReason.reasonTooltip
        }));
}
